export const checkIfDbIsOnline = async () => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/db_init`, {
      method: "GET",
    });
    const result = await response.json();

    if (result?.isDbAwake) {
      return true;
    }
    return false;
  } catch (err) {
    console.error(err.message);
    return false;
  }
};

const CHECK_DB_INTERVAL_IN_SECONDS = 2;
const MAX_CHECKS_COUNT = 4;

export const waitUntilDbIsOnline = async () => {
  let isDbAwake = await checkIfDbIsOnline();
  let checksCount = 0;
  while (!isDbAwake && checksCount < MAX_CHECKS_COUNT) {
    await new Promise((resolve) =>
      setTimeout(resolve, CHECK_DB_INTERVAL_IN_SECONDS * 1000)
    );
    isDbAwake = await checkIfDbIsOnline();
    checksCount++;
  }
  return isDbAwake;
};

export const PASSWORD_MIN_LENGTH = 8;

export const required = "is required";

export const passwordValidation = {
  required,
  validate: {
    minLength: (value) =>
      value.length >= PASSWORD_MIN_LENGTH ||
      `Min length is ${PASSWORD_MIN_LENGTH}`,
    // noWhiteSpaces: value =>
    //   !!value.match(RegExp('^[^\\s]*$')) || 'need no whitespaces',
    oneLowercase: (value) =>
      !!value.match(RegExp("(.*[a-z].*)")) || "need one lowercase character",
    oneUppercase: (value) =>
      !!value.match(RegExp("(.*[A-Z].*)")) || "need one uppercase character",
    oneNumber: (value) =>
      !!value.match(RegExp("(.*\\d.*)")) || "need one number character",
    oneSpecialChar: (value) =>
      !!value.match(RegExp('[!@#$%^&*(),.?":{}|<>]')) ||
      "need one special character (e.g “!@#$%^&*)",
  },
};

export const getPasswordConfirmValidation = (password) => ({
  validate: (value) => value === password || "Passwords must match",
});

export const displayLocalDateTime = (dateTime) => {
  if (!dateTime) {
    return null;
  }
  const localDateTime = `${dateTime?.slice(0, 19).split(" ").join("T")}.000Z`;
  const date = new Date(localDateTime);
  return new Intl.DateTimeFormat("en-US", {
    dateStyle: "short",
    timeStyle: "short",
  }).format(date);
};

export const displayDobTime = (dateTime) => {
  if (!dateTime) {
    return null;
  }

  const date = new Date(dateTime);
  const month = (date.getUTCMonth() + 1).toString(); // Months are zero-based
  const day = date.getUTCDate().toString();
  const year = date.getUTCFullYear();
  const result = `${month}/${day}/${year}`;

  return result;
};

export const getLocationOptions = (locations) => {
  return locations?.reduce(
    (acc, { id, name, street, street2, city, state, zipCode }) => {
      const address = `${street}${
        street2 ? `, ${street2}` : ""
      }, ${city}, ${state} ${zipCode}`;
      return {
        ...acc,
        [id]: `${name} - ${address}`,
      };
    },
    {}
  );
};

export const getProviderOptions = (providers) => {
  return providers?.reduce(
    (acc, { id, name, speciality }) => ({
      ...acc,
      [id]: [name, speciality].filter(Boolean).join(", "),
    }),
    {}
  );
};

export const mapNewPracticeWithNewSenderQuestionPayload = (source) => ({
  externalForm: source?.externalForm || null,
  newSender: {
    firstName: source?.firstName?.trim() || null,
    lastName: source?.lastName?.trim() || null,
    email: source?.email?.trim() || null,
    phone: source?.phone?.trim() || null,
    jobTitle: source?.jobTitle || null,
  },
  providerId: source?.providerId || null,
  practiceId: source?.practiceId || null,
  newPractice: {
    name: source?.practiceName?.trim() || null,
    street: source?.street?.trim() || null,
    street2: source?.street2?.trim() || null,
    city: source?.city?.trim() || null,
    state: source?.state || null,
    zipCode: source?.zipCode?.trim() || null,
    phone: source?.practicePhone || null,
    speciality: source?.speciality?.trim() || null,
  },
  question: source?.question?.trim() || null,
  locationId: source?.locationId || null,
  captchaId: source?.captchaId || null,
  code: source?.code?.trim() || null,
});

export const mapNewPracticeWithNewSenderReferralPayload = (source) => ({
  newSender: {
    firstName: source?.firstName?.trim() || null,
    lastName: source?.lastName?.trim() || null,
    email: source?.email?.trim() || null,
    phone: source?.phone || null,
    jobTitle: source?.jobTitle?.trim() || null,
  },
  providerId: source?.providerId || null,
  practiceId: source?.practiceId || null,
  newPractice: {
    name: source?.practiceName?.trim() || null,
    street: source?.street?.trim() || null,
    street2: source?.street2?.trim() || null,
    city: source?.city?.trim() || null,
    state: source?.state || null,
    zipCode: source?.zipCode?.trim() || null,
    phone: source?.practicePhone || null,
    speciality: source?.speciality?.trim() || null,
  },
  externalForm: source?.externalForm || null,
  locationId: source?.locationId || null,
  patientName: source?.patientName?.trim() || null,
  patientPhone: source?.patientPhone || null,
  patientDob: source?.patientDob || null,
  patientLocation: source?.patientLocation?.trim() || null,
  gender: source?.gender || null,
  urgency: source?.urgency || null,
  reason: source?.reason?.trim() || null,
  uploadedFileIds: source?.uploadedFileIds || [],
  captchaId: source?.captchaId || null,
  code: source?.code?.trim() || null,
});

export const replaceNullableValuesWithNull = (values) =>
  Object.entries(values).reduce(
    (acc, [key, value]) => ({
      ...acc,
      [key]:
        value === "" || value === undefined
          ? null
          : typeof value === "string"
          ? value?.trim()
          : value,
    }),
    {}
  );
